import { QUERY_INTERACTION_TARGET, SOCIAL_INTERACTION_TARGETS_QUERY, } from '../graphql';
export const updateInteractionsCache = ({ interaction, apolloClient, viewer, }) => {
    apolloClient.writeQuery({
        query: QUERY_INTERACTION_TARGET,
        variables: { urn: interaction.id },
        data: {
            viewer: {
                ...viewer,
                socialInteractionTarget: {
                    ...interaction,
                    __typename: 'SocialInteractionTarget',
                },
                __typename: 'Viewer',
            },
        },
    });
    apolloClient.writeQuery({
        query: SOCIAL_INTERACTION_TARGETS_QUERY,
        variables: { urns: [interaction.id] },
        data: {
            viewer: {
                ...viewer,
                socialInteractionTargets: [
                    { ...interaction, __typename: 'SocialInteractionTarget' },
                ],
                __typename: 'Viewer',
            },
        },
    });
};
//# sourceMappingURL=update-interactions-cache.js.map